let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("diDkp")).then(() => parcelRequire('lbx4H'));